import {FC} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

import {selectViewOrder} from 'app/features/orders/redux/order/orderSlice'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {CustomerOrderView} from 'app/features/orders/componentsv1'

interface Props {}

const CustomerWrapper: FC<Props> = () => {
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)

  return (
    <CustomerOrderView
      {...order.customer}
      orderCustomer={{name: order.name, email: order.email}}
      orderDeliveryMethod={order.orderDeliveryMethod}
      giftMessage={order.giftMessage}
    />
  )
}

export default CustomerWrapper
